import Text from 'components/commons/text';
import { CSS, styled } from 'styles';
import typography from 'styles/typography';

export const ItemCard = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 10,
  border: '1px solid $dbGray1',
  mb: 16,
  padding: 16,
  '@md': {
    py: 16,
    px: 24,
  },
  overflow: 'hidden',
});

export const SmallLabel = styled(Text, {
  ...typography.body5,
  '@md': {
    ...typography.body4,
  },
  fontWeight: '600 !important',
  mb: 4,
  color: '$typeGray',
});

export const ValueText = styled(Text, {
  maxWidth: '100%',
  whiteSpace: 'wrap',
  overflow: 'hidden',

  ...typography.body3,
  '@md': {
    ...typography.body2,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 150,
  },
  '@lg': {
    maxWidth: 190,
  },
  fontWeight: '600 !important',
});

export const HeaderText = styled(Text, {
  ...typography.headline7,
  '@md': {
    ...typography.headline5,
  },
});

const content: CSS = {
  flexBasis: '100%',
  flexDirection: 'column',
  gap: 16,
  justifyContent: 'space-between',
  '@md': {
    flexDirection: 'row',
    flexBasis: '47%',
  },
};

export const styles = {
  content,
};
